import { useState, useEffect, useCallback } from 'react';
import { NavLink, generatePath, useNavigate } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import copy from 'copy-to-clipboard';
import {
  IconChat,
  // IconLink,
  ButtonSecondary,
  ButtonPrimary,
  IconSelected,
  Select,
  Popup,
  IconDown,
  IconUp,
  ClickOutsideDetector,
  formatDate,
  PermissionEnum,
  ResponseError,
  responseErrorsResolver,
  SidePanel,
  SidePanelType,
  ChangeLogs,
  PermissionDenied,
  ButtonPseudo,
  IconInfo,
  IconUser,
  IconChangeLoClock,
  Tabs,
  IconCopyTwo,
  InputText,
  formatPhone,
  IconCopy,
  SecuritySidepanelLogsList,
  SecuritySidepanelLocksList,
  SecurityLockForm,
  IconLock,
  IconArrowRight,
  ToggleInput,
  IconClose,
  InputNumber,
} from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import NewApplicationMatches from '../../components/new-application/matches';
import Steps from '../../components/new-application/steps';
import ProcessingResult from '../../components/new-application/processing-result';
import {
  useSetReviewEmployeeMutation,
  useSubmitApplicationMutation,
  useUpdateNewApplicationMutation,
  useUpdateCorporateApplicationMutation,
  useUpdateCompanyOfficialApplicationMutation,
  useUpdateCOFQuestionnarieMutation,
  useUpdateInividualQuestionnarieMutation,
  useUpdateCorporateQuestionnarieMutation,
  useResetApplicationClientPasswordMutation,
  useLazyGetApplicationChangeLogsQuery,
  useLazyGetApplicationClientAuditLogsQuery,
  useLazyGetApplicationClientLocksQuery,
  useLazyGetApplicationClientLockItemQuery,
  useCreateApplicationClientLockMutation,
  useUpdateApplicationClientLockMutation,
  useLazyGetApplicationClientLockItemAuditLogsQuery,
  useLazyGetApplicationClientActiveLocksQuery,
  useUpdateApplicationClientMutation,
  useCreateApplicationManualRiskScoreMutation,
  useLazyGetApplicationsAMLScoresHistoryQuery,
} from './store/services';
import {
  NewApplicationStatus,
  NewApplicationStepStatus,
  ReviewStatus,
  ApplicationType,
  ApplicationComment,
  NewApplicationInfoTopTypes,
} from './types';
import getStatusClassName from './helpers/get-status-class-name';
import getApplicationStatus from './helpers/get-status-name';
import {
  COFAndIndividualQuestionnarieFormValues,
  CorporateQuestionnarieFormValues,
} from '../customers/types';
import getIndividualApplicationBody from './individual/helpers/get-individual-application-body';
import getCorporateAppicationBody from './corporate/helpers/get-corporate-application-body';
import getCofandIndividualQuestionnarieBody from './individual/helpers/get-qestionnarie-body';
import getCorporateQuestionnarieBody from './corporate/helpers/get-questionnarie-body';
import SystemLogs from '../../components/new-application/system-logs';
import {
  clearLockPanelState,
  clearDetailsPanelState,
  clearAmlChangeLogs,
} from './store/slices';
import ApplicationRiskScore from '../../components/new-application/risk-score';
import {
  auditLogsColumns,
  auditLogsColumnsLabels,
  auditLogsFiltersSchema,
  auditLogsSchema,
  columns,
  columnsLabels,
  filtersSchema,
  locksColumns,
  locksColumnsLabels,
  locksFiltersSchema,
  locksSchema,
  logsSchema,
} from './variables/list';
import AmlChangeLogs from '../customers/aml-change-logs/change-logs';

import ROUTES from '../../routes';

import cn from './new-application.module.css';

let manualRiskScoreTimeout: NodeJS.Timeout;

const NewApplicationInfoTop = ({
  status,
  reviewStatus,
  setPopupVisible,
  sendCommentIsSuccess,
  setMatchSelected,
  onSendComment,
  matches,
  onSubmit,
  onCreate,
  createInProgress,
  reviewedDuplicates,
  stepsStatus,
  applicationId,
  isCorporate,
  requestInProgress,
  comments,
  fields,
  sendCommentInProgress,
  defaultFormValues,
  isCompanyOfficial,
  reviewDuplicatesComment,
  applicationType,
  isEditable,
  reviewEmployee,
  // phone,
  // email,
  createAvailable,
  employeesList,
  canSelectResponsible,
  onAddResponsible,
  addResponsibleInProgress,
  addResponsibleIsSuccess,
  organizationId,
  title,
  backToIncompleteInProgress,
  onBackToIncomplete,
  createdDate,
  statusChangeError,
  applicationChat,
  riskScore,
  applicationScheme,
  setError,
  basePersonalInfoEditable,
  clearErrors,
  questionnarieFields,
  defaultQuestionnarieFormValues,
  customersSuppliersStepEnabled,
  questionnarieSetError,
  questionnarieClearErrors,
  changeLogs,
  changeLogsPagination,
  systemLogs,
  client,
  riskScoreIsLoading,
  riskScoreUpdateIsSuccess,
  riskScoreRequestInProgress,
  amlUpdateStatus,
  onUpdate,
  getApplicationRiskScore,
  totalIncomeError,
  onSaveAccountsCurrencies,
  accountsCurrenciesValues,
  accountsCurrencies,
  onSaveAccountsFlows,
  accountsFlowsValues,
  accountsFlows,
  onSaveExpectedFundsOrigins,
  expectedFundsOriginsValues,
  expectedFundsOrigins,
  stepOneBlockLoadingInProgress,
  onSaveCrsAndFatca,
  crsAndFatcaValues,
  crsAndFatca,
  onSaveAffilatedCompany,
  affilatedCompaniesValues,
  affilatedCompanies,
  percentageError,
  setHaveSecondPassport,
  haveSecondPassport,
}: NewApplicationInfoTopTypes) => {
  // const [copyEffect, setCopyEffect] = useState(false);
  const [rejectNotifyPopupVisible, setRejectNotifyPopupVisible] =
    useState(false);
  const [textareaIsVisible, setTextareaIsVisible] = useState(false);
  const [responsiblePopupVisible, setResponsiblePopupVisible] = useState(false);
  const [selectedResponsible, setSelectedResponsible] = useState('');
  const [withStatusChange, setWithStatusChange] = useState(false);
  const [actionMenuVisible, setActionMenuVisibile] = useState(false);
  const [duplicatesCollapsed, setDuplicatesCollapsed] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [globalError, setGlobalError] = useState('');
  const [questionnarieGlobalError, setQuestionnarieGlobalError] = useState('');
  const [changeLogsPanelIsOpen, setChangeLogsPanelIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'system' | 'change'>('system');
  const [userSidepanelVisible, setUserSidepanelVisible] = useState(false);
  const [resetPopupUpVisible, setResetPopupVisible] = useState(false);
  const [token, setToken] = useState('');
  const [resetCopyIsSuccess, setResetCopyIsSuccess] = useState(false);
  const [idCopySuccess, setIdCopySuccess] = useState(false);
  const [userDetailsActiveTab, setUserDetailsActiveTab] = useState<
    'general' | 'locks' | 'logs'
  >('general');
  const [lockId, setLockId] = useState('');
  const [lockFormVisible, setLockFormVisible] = useState(false);
  const [activeStatus, setActiveStatus] = useState('');
  const [totalRiskScore, setTotalRiskScore] = useState(0);
  const [totalRiskScoreLevel, setTotalRiskScoreLevel] = useState('');
  const [manualScoreSidepanelVisible, setManualScoreSidepanelVisible] =
    useState(false);
  const [manualRiskScoreError, setManualRiskScoreError] = useState('');
  const [
    riskScoreChangeLogsSidepanelVisible,
    setRiskScoreChangeLogsSidepanelVisible,
  ] = useState(false);

  // const onCopy = useCallback(() => {
  //   copy(
  //     `${window.location.origin}${generatePath(ROUTES.SUMSUB, {
  //       applicationId: applicationId as string,
  //     })}?phone=${phone}${email ? `&email=${email}` : ''}`,
  //   );
  //   setCopyEffect(true);

  //   setTimeout(() => {
  //     setCopyEffect(false);
  //   }, 2000);
  // }, [window.location]);

  const navigate = useNavigate();

  const [updateInfo, { isLoading: udpateInProgress }] =
    useUpdateNewApplicationMutation();
  const [updateCOFInfo, { isLoading: udpateCofInProgress }] =
    useUpdateCompanyOfficialApplicationMutation();
  const [updateCorporateInfo, { isLoading: udpateCorporateInProgress }] =
    useUpdateCorporateApplicationMutation();
  const [
    getChangeLogs,
    { isLoading: changeLogsIsLoading, isFetching: changeLogsIsFetching },
  ] = useLazyGetApplicationChangeLogsQuery();

  const [
    updateCOFQuestionnarie,
    { isLoading: updateCofQuestionnarieInProgress },
  ] = useUpdateCOFQuestionnarieMutation();
  const [
    updateIndividualQuestionnarie,
    { isLoading: updateIndividualQuestionnarieInProgress },
  ] = useUpdateInividualQuestionnarieMutation();
  const [
    updateCorporateQuestionnarie,
    { isLoading: updateCorporateQuestionnarieInProgress },
  ] = useUpdateCorporateQuestionnarieMutation();

  const [onSubmitApplication, { isLoading: submitIsLoading }] =
    useSubmitApplicationMutation();
  const [resetCustomerPassword, { isLoading: recoveryInProgress }] =
    useResetApplicationClientPasswordMutation();
  const [
    getListAuditLogs,
    { isFetching: auditLogsIsFetching, isLoading: auditLogsIsLoading },
  ] = useLazyGetApplicationClientAuditLogsQuery();
  const [getLocks, { isLoading: locksIsLoading, isFetching: locksIsFetching }] =
    useLazyGetApplicationClientLocksQuery();
  const [
    getLockItem,
    { isLoading: lockItemIsLoading, isFetching: lockItemIsFetching },
  ] = useLazyGetApplicationClientLockItemQuery();
  const [create, { isLoading: createLockRequestInProgress, isSuccess }] =
    useCreateApplicationClientLockMutation();
  const [
    update,
    { isLoading: updateInProgress, isSuccess: updateLockIsSuccess },
  ] = useUpdateApplicationClientLockMutation();
  const [
    getLockItemLogsList,
    { isFetching: lockItemLogsIsFetching, isLoading: lockItemLogsIsLoading },
  ] = useLazyGetApplicationClientLockItemAuditLogsQuery();
  const [getClientActiveLock] = useLazyGetApplicationClientActiveLocksQuery();
  const [updateClient, { isLoading: updateClientInProgress }] =
    useUpdateApplicationClientMutation();
  const [
    createApplicationManualRiskScore,
    {
      isLoading: createRiskScoreIsLoading,
      isSuccess: createRiskScoreIsSuccess,
    },
  ] = useCreateApplicationManualRiskScoreMutation();
  const [
    getApplicationsAmlScoresHistory,
    {
      isLoading: amlScoresHistoryIsLoading,
      isFetching: amlScoresHistoryIsFetching,
    },
  ] = useLazyGetApplicationsAMLScoresHistoryQuery();

  const getChangeLogsAction = useCallback(
    (cursor?: string) => {
      getChangeLogs(
        `?take=20&entityType=APPLICATION&entityId=${applicationId}${
          cursor ? `&cursor=${cursor}` : ''
        }`,
      );
    },
    [applicationId],
  );

  const getApplicationsAmlScoresHistoryAction = async (cursor?: string) => {
    await getApplicationsAmlScoresHistory({
      id: applicationId as string,
      query: `?take=40&${cursor ? `&cursor=${cursor}` : ''}`,
    });
  };

  let link: string;

  if (process.env.CUSTOMERS_HOST) {
    link = process.env.CUSTOMERS_HOST;
  } else {
    link = window.location.host.includes('baseella')
      ? window.location.host.replace('backoffice', 'customers')
      : '';
  }

  const dispatch = useAppDispatch();

  const onResetPassword = async () => {
    const response = (await resetCustomerPassword(client?.id as string)) as {
      data: { data: { token: string } };
    };

    if (response && response.data && response.data.data) {
      setToken(response.data.data.token);
      setResetPopupVisible(true);
    }
  };

  const createApplicationManualRiskScoreAction = async () => {
    setManualRiskScoreError('');

    const response = (await createApplicationManualRiskScore({
      id: applicationId as string,
      totalRiskScore,
    })) as { error?: ResponseError };

    if (response?.error) {
      responseErrorsResolver({
        errors: response.error,
        setError: () => {},
        setGlobalError: setManualRiskScoreError,
      });
    }
  };

  const onUpdateClientStatus = (clientStatus: 'ACTIVE' | 'DISABLED') => {
    setActiveStatus(clientStatus);

    updateClient({
      id: client?.id as string,
      body: {
        status: clientStatus,
      },
    });
  };

  const onIDCopy = (id: string) => {
    copy(id);

    setIdCopySuccess(true);

    setTimeout(() => {
      setIdCopySuccess(false);
    }, 2000);
  };

  const onResetCopy = () => {
    copy(`${link}/auth/reset-password?token=${token}`);

    setResetCopyIsSuccess(true);

    setTimeout(() => {
      setResetCopyIsSuccess(false);
    }, 2000);
  };

  const onSubmitApplicationAction = async () => {
    clearErrors([]);
    questionnarieClearErrors([]);
    setSubmitError('');
    setGlobalError('');
    setQuestionnarieGlobalError('');

    let updateResponse: any;

    if (!isCorporate && !isCompanyOfficial) {
      const body = getIndividualApplicationBody(
        fields as any,
        basePersonalInfoEditable as boolean,
      );

      const updateBody = {
        ...body,
        participatesInPolitics: Boolean(
          fields?.participatesInPolitics === 'yes',
        ),
        isUSResident: Boolean(fields?.isUSResident === 'yes'),
      };

      updateResponse = await updateInfo({
        body: updateBody,
        id: applicationId as string,
      });

      if (
        applicationScheme &&
        (applicationScheme?.civilActive ||
          applicationScheme?.criminalOfAnyActive ||
          applicationScheme?.lastThreeYearsAddressHistoryActive ||
          applicationScheme?.nationalInsuranceNumberOfDirectorsActive ||
          applicationScheme?.regulatoryActive ||
          applicationScheme?.businessAndEmploymentActive ||
          applicationScheme?.id === 'ed560559-8354-4634-b6dd-eb341dfb551a')
      ) {
        const questionnarieBody = getCofandIndividualQuestionnarieBody({
          questionnarieValues:
            questionnarieFields as COFAndIndividualQuestionnarieFormValues,
          scheme: applicationScheme,
        });

        updateIndividualQuestionnarie({
          id: applicationId as string,
          body: questionnarieBody,
        });

        if (
          applicationScheme?.id === 'ed560559-8354-4634-b6dd-eb341dfb551a' &&
          onSaveAccountsCurrencies &&
          onSaveAccountsFlows &&
          onSaveExpectedFundsOrigins &&
          onSaveCrsAndFatca
        ) {
          onSaveAccountsCurrencies();
          onSaveAccountsFlows();
          onSaveExpectedFundsOrigins();
          onSaveCrsAndFatca();
        }
      }
    } else if (isCompanyOfficial) {
      const body: {
        firstName?: string;
        lastName?: string;
        nationalityId?: string;
        email?: string;
        dob?: string;
        deliveryChannelId?: string;
        taxNumber?: string;
      } = {};
      if (fields?.nationalityId) {
        body.nationalityId = fields.nationalityId;
      }

      if (fields?.taxNumber) {
        body.taxNumber = fields.taxNumber;
      }

      if (fields?.deliveryChannelId) {
        body.deliveryChannelId = fields.deliveryChannelId;
      }

      const updateBody = {
        ...body,
        participatesInPolitics: Boolean(
          fields?.participatesInPolitics === 'yes',
        ),
        isUSResident: Boolean(fields?.isUSResident === 'yes'),
      };

      updateResponse = await updateCOFInfo({
        body: updateBody,
        id: applicationId as string,
      });

      if (
        applicationScheme &&
        (applicationScheme?.civilActive ||
          applicationScheme?.criminalOfAnyActive ||
          applicationScheme?.lastThreeYearsAddressHistoryActive ||
          applicationScheme?.nationalInsuranceNumberOfDirectorsActive ||
          applicationScheme?.regulatoryActive ||
          applicationScheme?.businessAndEmploymentActive ||
          applicationScheme?.id === 'a87db4b4-3c78-4564-bba1-c16a19553159')
      ) {
        const questionnarieBody = getCofandIndividualQuestionnarieBody({
          questionnarieValues:
            questionnarieFields as COFAndIndividualQuestionnarieFormValues,
          scheme: applicationScheme,
        });

        updateCOFQuestionnarie({
          id: applicationId as string,
          body: questionnarieBody,
        });

        if (
          applicationScheme?.id === 'a87db4b4-3c78-4564-bba1-c16a19553159' &&
          onSaveAffilatedCompany &&
          onSaveCrsAndFatca
        ) {
          onSaveAffilatedCompany();
          onSaveCrsAndFatca();
        }
      }
    } else if (isCorporate) {
      const body = getCorporateAppicationBody(fields as any);

      if (!body.websiteLink) {
        body.websiteLink = '';
      }

      const updateBody = body;

      updateResponse = await updateCorporateInfo({
        body: updateBody,
        id: applicationId as string,
      });

      if (
        applicationScheme &&
        (applicationScheme?.accountantDetailsActive ||
          applicationScheme?.auditedByExternalComplianceActive ||
          applicationScheme?.changesInManagementOrOwnershipActive ||
          applicationScheme?.complianceConsultantDetailsActive ||
          applicationScheme?.fcaNumberActive ||
          applicationScheme?.hmrcMlrNumberActive ||
          applicationScheme?.hmrcRegistrationExpiryDateActive ||
          applicationScheme?.icoNumberActive ||
          applicationScheme?.itProviderDetailsActive ||
          applicationScheme?.mlroDetailsActive ||
          applicationScheme?.numberOfAgentsActive ||
          applicationScheme?.numberOfBranchesActive ||
          applicationScheme?.onboardCorporateClientsActive ||
          applicationScheme?.onboardMsbActive ||
          applicationScheme?.paymentsForCharitiesActive ||
          applicationScheme?.payoutPartnerDetailsActive ||
          applicationScheme?.regulatoryInvestigationActive ||
          applicationScheme?.screeningActive ||
          applicationScheme?.transactionMonitoringActive ||
          applicationScheme?.typeOfBusinessLicenceActive ||
          applicationScheme?.visitedByAuthoritiesActive ||
          applicationScheme?.workingWithAnyOtherIPSPActive ||
          applicationScheme?.id === 'cdbb8c71-90e6-4a5e-964f-e55169e0c4df')
      ) {
        const questionnarieBody = getCorporateQuestionnarieBody({
          questionnarieValues:
            questionnarieFields as CorporateQuestionnarieFormValues,
          scheme: applicationScheme,
        });

        updateCorporateQuestionnarie({
          id: applicationId as string,
          body: questionnarieBody,
        });

        if (
          applicationScheme?.id === 'cdbb8c71-90e6-4a5e-964f-e55169e0c4df' &&
          onSaveAccountsCurrencies &&
          onSaveAccountsFlows &&
          onSaveExpectedFundsOrigins
        ) {
          onSaveAccountsCurrencies();
          onSaveAccountsFlows();
          onSaveExpectedFundsOrigins();
        }
      }
    }

    if (updateResponse) {
      const response = (await onSubmitApplication(applicationId as string)) as {
        error?: ResponseError;
      };

      if (
        response?.error?.data?.message &&
        Array.isArray(response?.error?.data?.message)
      ) {
        if (
          (response?.error?.data?.message?.find(
            (item) => item.property === 'secondPassportIssueCountryId',
          ) ||
            response?.error?.data?.message?.find(
              (item) => item.property === 'secondPassportNumber',
            ) ||
            response?.error?.data?.message?.find(
              (item) => item.property === 'secondPassportIssueDate',
            )) &&
          setHaveSecondPassport &&
          !haveSecondPassport
        ) {
          setHaveSecondPassport(true);
        }
      }

      if (response.error) {
        responseErrorsResolver({
          errors: response.error,
          setError,
          setGlobalError,
        });

        responseErrorsResolver({
          errors: response.error,
          setError: questionnarieSetError,
          setGlobalError: setQuestionnarieGlobalError,
        });

        setSubmitError('There are some errors in application');
      }
    }
  };

  const [
    setReviewEmployee,
    {
      isLoading: setReviewEmployeeInProgress,
      isSuccess: setReviewEmployeeIsSuccess,
    },
  ] = useSetReviewEmployeeMutation();

  const setReviewEmployeeAction = () => {
    setReviewEmployee({
      id: applicationId as string,
      body: {
        reviewEmployeeId: selectedResponsible,
      },
    });
  };

  const {
    newApplications: {
      list: {
        currentEmployee,
        auditLogs,
        auditLogsPagination,
        locks,
        locksPagination,
        lockItem,
        lockItemAuditLogs,
        lockItemAuditLogsPagination,
        activeLock,
        amlChangeLogs,
        amlChangeLogsPagination,
      },
    },
    customersDictionaries: { activePermissions, riskScoreRanges },
    administrationDictionaries: { users },
    userList: {
      users: { users: employees },
    },
  } = useAppSelector((state) => state);

  const { reviewStatusText, statusClassName } = getStatusClassName({
    status: status as NewApplicationStatus,
    reviewStatus,
  });

  const handleCloseAmlChangeLogsPanel = () => {
    setRiskScoreChangeLogsSidepanelVisible(false);
    dispatch(clearAmlChangeLogs());
  };

  let createCustomerButtonDisabled: boolean;
  let createAppliсationButtonDisabled = false;

  if (!isCorporate) {
    createCustomerButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFive !== NewApplicationStepStatus.COMPLETED,
    );

    if (isCompanyOfficial) {
      createCustomerButtonDisabled = Boolean(
        stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED,
      );
    }
  } else {
    createCustomerButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFive !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepSix !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepSeven !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepEight !== NewApplicationStepStatus.COMPLETED,
    );

    createAppliсationButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED,
    );
  }

  useEffect(() => {
    if (sendCommentIsSuccess) {
      setTextareaIsVisible(false);
    }
  }, [sendCommentIsSuccess]);

  useEffect(() => {
    if (
      changeLogsPanelIsOpen &&
      !changeLogs &&
      activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)
    ) {
      getChangeLogsAction();
    }
  }, [changeLogsPanelIsOpen]);

  useEffect(() => {
    if (
      addResponsibleIsSuccess ||
      (!withStatusChange && setReviewEmployeeIsSuccess)
    ) {
      setResponsiblePopupVisible(false);
      setSelectedResponsible('');
      setWithStatusChange(false);
    }
  }, [addResponsibleIsSuccess, setReviewEmployeeIsSuccess, withStatusChange]);

  useEffect(() => {
    if (
      !reviewEmployee &&
      !selectedResponsible &&
      responsiblePopupVisible &&
      currentEmployee
    ) {
      setSelectedResponsible(currentEmployee.id);
    }
  }, [
    responsiblePopupVisible,
    selectedResponsible,
    currentEmployee,
    reviewEmployee,
  ]);

  useEffect(() => {
    if (createRiskScoreIsSuccess) {
      setManualRiskScoreError('');
      setTotalRiskScore(0);
      setTotalRiskScoreLevel('');
      setManualScoreSidepanelVisible(false);

      if (getApplicationRiskScore) {
        getApplicationRiskScore();
      }
    }
  }, [createRiskScoreIsSuccess, getApplicationRiskScore]);

  useEffect(() => {
    if (
      reviewedDuplicates &&
      reviewedDuplicates?.length > 0 &&
      reviewStatus !== ReviewStatus.HAS_DUPLICATE
    ) {
      setDuplicatesCollapsed(true);
    }
  }, [reviewStatus, reviewedDuplicates]);

  useEffect(() => {
    if (reviewEmployee && !selectedResponsible && responsiblePopupVisible) {
      setSelectedResponsible(reviewEmployee.id);
    }
  }, [reviewEmployee, selectedResponsible, responsiblePopupVisible]);

  useEffect(() => {
    if (userSidepanelVisible && client) {
      getClientActiveLock(client?.id);
    }
  }, [userSidepanelVisible, client]);

  useEffect(() => {
    if (isSuccess || updateLockIsSuccess) {
      getClientActiveLock(client?.id as string);
    }
  }, [isSuccess, updateLockIsSuccess]);

  useEffect(() => {
    if (client) {
      setActiveStatus(client?.status);
    }
  }, [client]);

  useEffect(() => {
    if (riskScore && riskScoreRanges && manualScoreSidepanelVisible) {
      setTotalRiskScore(riskScore?.totalRiskScore);

      setTotalRiskScoreLevel(
        riskScoreRanges?.find(
          (item) =>
            riskScore?.totalRiskScore >= item.rangeStart &&
            riskScore?.totalRiskScore <= item.rangeEnd,
        )?.id as string,
      );
    }
  }, [riskScore, riskScoreRanges, manualScoreSidepanelVisible]);

  let systemLogContent = (
    <div className={cn.emptyChangeLogs}>No system logs yet</div>
  );

  if (systemLogs && systemLogs.length) {
    systemLogContent = <SystemLogs systemLogs={systemLogs} />;
  }

  return (
    <>
      <div className={cn.newApplicationTop}>
        <div className={cn.newApplicationTopInfo}>
          <div className={cn.newApplcationTopControls}>
            <div className={cn.newApplicationName}>{title}</div>
            <div className={cn.newApplicationTopRight}>
              {status !== NewApplicationStatus.DECLINED &&
                status !== NewApplicationStatus.ACCEPTED && (
                  <>
                    {applicationId && isEditable && (
                      <ButtonSecondary
                        className={`button-white ${cn.saveChangesButton} ${cn.applicationTopButton}`}
                        text={requestInProgress ? 'Loading...' : 'Save changes'}
                        onClick={onSubmit}
                        disabled={
                          (Boolean(isEqual(fields, defaultFormValues)) &&
                            Boolean(
                              isEqual(
                                questionnarieFields,
                                defaultQuestionnarieFormValues,
                              ),
                            ) &&
                            Boolean(
                              isEqual(
                                accountsCurrenciesValues || [],
                                accountsCurrencies || [],
                              ),
                            ) &&
                            Boolean(
                              isEqual(
                                accountsFlowsValues || [],
                                accountsFlows || [],
                              ),
                            ) &&
                            Boolean(
                              isEqual(
                                crsAndFatcaValues || [],
                                crsAndFatca || [],
                              ),
                            ) &&
                            Boolean(
                              isEqual(
                                expectedFundsOriginsValues || [],
                                expectedFundsOrigins || [],
                              ),
                            ) &&
                            Boolean(
                              isEqual(
                                affilatedCompaniesValues || [],
                                affilatedCompanies || [],
                              ),
                            )) ||
                          Boolean(totalIncomeError) ||
                          percentageError
                        }
                        bold
                      />
                    )}
                    <div className={cn.applicationActionsWrapper}>
                      <ClickOutsideDetector
                        setOptionsListVisible={setActionMenuVisibile}
                      >
                        <>
                          <button
                            type="button"
                            className={`${cn.applicationActionButton} ${
                              actionMenuVisible ? cn.active : ''
                            }`}
                            onClick={() =>
                              setActionMenuVisibile(!actionMenuVisible)
                            }
                            disabled={
                              backToIncompleteInProgress ||
                              submitIsLoading ||
                              udpateInProgress ||
                              udpateCofInProgress ||
                              udpateCorporateInProgress ||
                              updateCofQuestionnarieInProgress ||
                              updateIndividualQuestionnarieInProgress ||
                              updateCorporateQuestionnarieInProgress ||
                              stepOneBlockLoadingInProgress
                            }
                          >
                            {backToIncompleteInProgress ||
                            submitIsLoading ||
                            udpateInProgress ||
                            udpateCofInProgress ||
                            udpateCorporateInProgress ||
                            updateCofQuestionnarieInProgress ||
                            updateIndividualQuestionnarieInProgress ||
                            updateCorporateQuestionnarieInProgress ||
                            stepOneBlockLoadingInProgress
                              ? 'Loading...'
                              : 'Select action'}
                            {actionMenuVisible ? (
                              <IconUp width={13} height={13} />
                            ) : (
                              <IconDown
                                width={13}
                                height={13}
                                className={cn.iconDown}
                              />
                            )}
                          </button>
                          {actionMenuVisible && (
                            <div className={cn.actionMenu}>
                              {applicationId && isEditable && (
                                <>
                                  {status === NewApplicationStatus.INCOMPLETE &&
                                    activePermissions?.includes(
                                      PermissionEnum.APPLICATIONS_CUSTOMERS_SUBMIT_ACTION,
                                    ) && (
                                      <button
                                        type="button"
                                        className={cn.actionMenuButton}
                                        onClick={() => {
                                          setActionMenuVisibile(false);
                                          onSubmitApplicationAction();
                                        }}
                                      >
                                        Submit application
                                      </button>
                                    )}
                                  <button
                                    type="button"
                                    className={cn.actionMenuButton}
                                    onClick={() => {
                                      if (!comments?.length) {
                                        setRejectNotifyPopupVisible(true);
                                      } else {
                                        setPopupVisible(true);
                                      }

                                      setActionMenuVisibile(false);
                                    }}
                                  >
                                    Reject application
                                  </button>
                                  {(status ===
                                    NewApplicationStatus.READY_TO_REVIEW ||
                                    status ===
                                      NewApplicationStatus.REVIEW_IN_PROGRESS) && (
                                    <button
                                      type="button"
                                      className={cn.actionMenuButton}
                                      onClick={() => {
                                        onBackToIncomplete();

                                        setActionMenuVisibile(false);
                                      }}
                                    >
                                      Back to “Incomplete” status
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </>
                      </ClickOutsideDetector>
                    </div>
                    <div className={cn.submitError}>
                      {submitError && <div>{submitError}</div>}
                      {globalError && <div>{globalError}</div>}
                      {questionnarieGlobalError && (
                        <div>{questionnarieGlobalError}</div>
                      )}
                    </div>

                    {!applicationId && (
                      <ButtonPrimary
                        className={`${cn.createButton} ${cn.applicationTopButton}`}
                        text="Create Application"
                        icon={<IconSelected />}
                        onClick={onSubmit}
                        disabled={createAppliсationButtonDisabled}
                        bold
                      />
                    )}
                    {reviewStatus !== ReviewStatus.HAS_DUPLICATE &&
                      status === NewApplicationStatus.REVIEW_IN_PROGRESS &&
                      createAvailable &&
                      applicationId && (
                        <ButtonPrimary
                          className={cn.createButton}
                          text={
                            createInProgress ? 'Loading...' : 'Create customer'
                          }
                          icon={<IconSelected />}
                          onClick={onCreate}
                          disabled={createCustomerButtonDisabled}
                          bold
                        />
                      )}
                    {status === NewApplicationStatus.READY_TO_REVIEW && (
                      <ButtonPrimary
                        text="Start review"
                        onClick={() => {
                          setResponsiblePopupVisible(true);
                          setWithStatusChange(true);
                        }}
                        disabled={!canSelectResponsible}
                        bold
                      />
                    )}
                  </>
                )}
              {status === NewApplicationStatus.ACCEPTED && organizationId && (
                <NavLink
                  className={cn.customerLink}
                  to={
                    isCorporate
                      ? generatePath(ROUTES.CUSTOMERS_CORPORATE_PAGE, {
                          customerId: organizationId,
                        })
                      : generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
                          customerId: organizationId,
                        })
                  }
                  target="_blank"
                >
                  Go to Сustomer
                </NavLink>
              )}
            </div>
          </div>
          <div className={cn.newApplicationBaseInfo}>
            <div
              className={`${cn.newApplicationBaseInfoItem} ${statusClassName}`}
            >
              {`${status ? getApplicationStatus(status) : 'Incomplete'}
               ${
                 reviewStatus === ReviewStatus.HAS_DUPLICATE
                   ? `(${reviewStatusText})`
                   : ''
               }
                `}
            </div>
            <div className={cn.newApplicationBaseInfoItem}>
              {formatDate(createdDate, true)}
              <div
                className={cn.newApplicationBaseInfoItemHint}
                data-text="Date created"
              >
                <IconInfo width={18} height={18} />
              </div>
            </div>
            {applicationScheme && (
              <NavLink
                to={`/settings/scheme/${applicationScheme?.id}`}
                target="_blank"
                className={cn.newApplicationBaseInfoItem}
              >
                {applicationScheme.name}
                <div
                  className={cn.newApplicationBaseInfoItemHint}
                  data-text="Application Scheme"
                >
                  <IconInfo width={18} height={18} />
                </div>
              </NavLink>
            )}
            {statusChangeError && (
              <div className={cn.statusChangeError}>{statusChangeError}</div>
            )}
          </div>
          <div className={cn.newApplicationInfoBottom}>
            <div className={cn.newApplicationInfoBottomLeft}>
              <button
                type="button"
                className={cn.newApplicationAssignResponsibleButton}
                onClick={() => setResponsiblePopupVisible(true)}
                disabled={
                  !canSelectResponsible ||
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                }
              >
                {reviewEmployee
                  ? `${reviewEmployee?.profile?.firstName} ${reviewEmployee?.profile?.lastName}`
                  : 'Select Responsible'}
                <IconDown className={cn.marginLeft} />
              </button>
              <div className={cn.newApplicationInfoBottomSeparator} />
              <button
                type="button"
                className={`${cn.newApplicationAssignResponsibleButton} ${cn.withPadding}`}
                onClick={() => setUserSidepanelVisible(true)}
              >
                <IconUser className={cn.marginRight} width={16} height={16} />
                View user
              </button>
              {applicationId && applicationChat && (
                <NavLink
                  to={`/messages/requests${
                    applicationChat.employee ? '/in-progress' : '/completed'
                  }/${applicationChat.id}`}
                  className={`${cn.newApplicationAssignResponsibleButton} ${cn.link}`}
                  target="_blank"
                >
                  <IconChat className={cn.marginRight} width={16} height={16} />
                  <span>Application chat</span>
                </NavLink>
              )}
              <button
                type="button"
                className={`${cn.newApplicationAssignResponsibleButton} ${cn.withPadding}`}
                onClick={() => setChangeLogsPanelIsOpen(true)}
              >
                <IconChangeLoClock
                  className={cn.marginRight}
                  width={17}
                  height={17}
                />
                Logs
              </button>
            </div>
            {applicationId && (
              <div className={cn.newApplicationId}>
                <div className={cn.newApplicationIdContent}>
                  {`ID: ${applicationId}`}
                </div>
                <button
                  type="button"
                  className={cn.copyButton}
                  aria-label="Copy application ID"
                  onClick={() => onIDCopy(applicationId)}
                >
                  <IconCopyTwo width={16} height={16} />
                  <div
                    className={`${cn.copySuccess} ${
                      idCopySuccess ? cn.visible : ''
                    }`}
                  >
                    Copied!
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {(applicationType === ApplicationType.INDIVIDUAL ||
        applicationType === ApplicationType.CORPORATE) &&
        activePermissions?.includes(
          PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_LIST,
        ) && (
          <ApplicationRiskScore
            aml={riskScore}
            type={applicationType}
            status={status}
            updateIsSuccess={riskScoreUpdateIsSuccess}
            requestInProgress={riskScoreRequestInProgress}
            calculateAllowed={activePermissions?.includes(
              PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_AUTO_ON_ACTION,
            )}
            manualScoreAllowed={activePermissions?.includes(
              PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_CREATE_ACTION,
            )}
            amlUpdateStatus={amlUpdateStatus}
            riskScoreIsLoading={riskScoreIsLoading}
            onUpdate={onUpdate}
            users={users}
            changeLogsAvailable={activePermissions?.includes(
              PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_LIST,
            )}
            setRiskScoreChangeLogsSidepanelVisible={
              setRiskScoreChangeLogsSidepanelVisible
            }
            setManualScoreSidepanelVisible={setManualScoreSidepanelVisible}
          />
        )}
      {matches && matches.length > 0 && (
        <NewApplicationMatches
          matches={matches}
          reviewDuplicatesComment={reviewDuplicatesComment}
          id={applicationId as string}
          setMatchSelected={(data) => setMatchSelected(data)}
          applicationType={applicationType}
          collapsed={duplicatesCollapsed}
          setCollapsed={setDuplicatesCollapsed}
          reviewedDuplicates={reviewedDuplicates}
          reviewStatus={reviewStatus}
          disabled={reviewStatus !== ReviewStatus.HAS_DUPLICATE}
        />
      )}
      <Steps
        steps={stepsStatus}
        isCorporate={isCorporate}
        isCompanyOfficial={isCompanyOfficial}
        applicationScheme={applicationScheme}
        customersSuppliersStepEnabled={customersSuppliersStepEnabled}
      />
      <ProcessingResult
        comments={comments as ApplicationComment[]}
        onCommentSend={(text) => onSendComment(text)}
        textareaIsVisible={textareaIsVisible}
        setTextareaIsVisible={setTextareaIsVisible}
        applicationId={applicationId}
        sendCommentInProgress={sendCommentInProgress}
      />
      <Popup
        title="Required comment"
        description="To reject the application, you must comment on the reason for the rejection."
        onCancelClick={() => setRejectNotifyPopupVisible(false)}
        onOkClick={() => {
          setTextareaIsVisible(true);
          setRejectNotifyPopupVisible(false);
        }}
        cancelButtonText="Cancel"
        okButtonText="Add comment"
        isVisible={rejectNotifyPopupVisible}
      />
      <Popup
        title="Select responsible for review"
        onCancelClick={() => {
          setResponsiblePopupVisible(false);
          setWithStatusChange(false);
        }}
        onOkClick={() => {
          if (!withStatusChange) {
            setReviewEmployeeAction();
          } else {
            const body: {
              status: NewApplicationStatus;
              id?: string;
            } = {
              status: NewApplicationStatus.REVIEW_IN_PROGRESS,
            };

            if (
              (reviewEmployee &&
                !isEqual(selectedResponsible, reviewEmployee.id)) ||
              !reviewEmployee
            ) {
              body.id = selectedResponsible;
            }

            onAddResponsible(body);
          }
        }}
        cancelButtonText="Cancel"
        okButtonText={
          addResponsibleInProgress || setReviewEmployeeInProgress
            ? 'Loading...'
            : 'Confirm'
        }
        isVisible={responsiblePopupVisible}
        isLoading={addResponsibleInProgress || setReviewEmployeeInProgress}
        popupClassName={cn.responsiblePopup}
      >
        <div className={cn.responsibleSelectWrapper}>
          <Select
            name="selectedResponsible"
            value={selectedResponsible}
            title="Responsible for review"
            placeholder="Select user"
            onChange={(e) => setSelectedResponsible(e.target.value as string)}
            list={employeesList}
          />
        </div>
      </Popup>
      <SidePanel
        isOpen={changeLogsPanelIsOpen}
        onClose={() => {
          setChangeLogsPanelIsOpen(false);
        }}
        errorSidepanel={globalError}
        title="Application change logs"
        sidepanelExpandedKey="application-change-logs"
        type={SidePanelType.Accounts}
        footer={
          <div>
            <ButtonPseudo
              text="Close"
              onClick={() => setChangeLogsPanelIsOpen(false)}
              bold
            />
          </div>
        }
        closeOnClickOutside
      >
        <>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <Tabs
              tabs={[
                {
                  name: 'System log',
                  value: 'system',
                },
                {
                  name: 'Change log',
                  value: 'change',
                },
              ]}
              activeTab={activeTab}
              onClick={(tab) => setActiveTab(tab as 'system' | 'change')}
              wrapperClassName={cn.applicationLogsTabs}
            />
          )}
          {activeTab === 'system' && systemLogContent}
          {activeTab === 'change' && (
            <>
              {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
                <ChangeLogs
                  entityType="APPLICATION"
                  entityId={applicationId as string}
                  changeLogsIsLoading={changeLogsIsLoading}
                  changeLogs={changeLogs}
                  activePermission={activePermissions}
                  users={users}
                  pagination={changeLogsPagination}
                  changeLogsIsFetching={changeLogsIsFetching}
                  getChangeLogs={getChangeLogsAction}
                />
              )}
              {!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
                <PermissionDenied />
              )}
            </>
          )}
        </>
      </SidePanel>
      <SidePanel
        title="Client details"
        sidepanelExpandedKey="application-client-details"
        isOpen={userSidepanelVisible}
        type={SidePanelType.Accounts}
        onClose={() => {
          setUserSidepanelVisible(false);
          setUserDetailsActiveTab('general');
          dispatch(clearDetailsPanelState());
        }}
        footer={
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setUserSidepanelVisible(false);
              setUserDetailsActiveTab('general');
              dispatch(clearDetailsPanelState());
            }}
            bold
          />
        }
        closeOnClickOutside
      >
        <>
          <Tabs
            tabs={[
              {
                name: 'Details',
                value: 'general',
              },
              {
                name: 'Locks',
                value: 'locks',
              },
              {
                name: 'Audit Logs',
                value: 'logs',
              },
            ]}
            activeTab={userDetailsActiveTab}
            wrapperClassName={cn.clientTabs}
            onClick={(tab) => {
              setUserDetailsActiveTab(tab as 'general' | 'locks' | 'logs');
            }}
          />
          {userDetailsActiveTab === 'general' && (
            <div className={cn.clientDetails}>
              {activeLock && (
                <div className={cn.lockInfo}>
                  <div className={cn.lockInfoLeft}>
                    <div className={cn.lockInfoIcon}>
                      <IconLock />
                    </div>
                    <div className={cn.lockInfoText}>
                      Authorization is locked
                    </div>
                  </div>
                  <div className={cn.lockInfoButtonWrapper}>
                    <button
                      type="button"
                      className={cn.lockInfoButton}
                      onClick={() => {
                        setUserDetailsActiveTab('locks');

                        let detailsLink = '';

                        if (applicationType === ApplicationType.CORPORATE) {
                          detailsLink =
                            ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO;
                        } else if (
                          applicationType === ApplicationType.INDIVIDUAL
                        ) {
                          detailsLink =
                            ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO;
                        } else if (
                          applicationType ===
                            ApplicationType.COMPANY_OFFICIAL ||
                          applicationType ===
                            ApplicationType.MAIN_REPRESENTATIVE
                        ) {
                          detailsLink =
                            ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL;
                        }

                        navigate(
                          `${generatePath(detailsLink, {
                            applicationId: applicationId as string,
                          })}?locked=true`,
                        );

                        if (locks) {
                          getLocks(`?take=20&userId=${client?.id}&locked=true`);
                        }
                      }}
                    >
                      <div className={cn.lockInfoButtonContent}>View locks</div>
                      <div className={cn.lockInfoButtonContent}>
                        <IconArrowRight width={12} height={12} />
                      </div>
                    </button>
                  </div>
                </div>
              )}
              <div className={cn.totpInfo}>
                {client?.totpEnabled ? (
                  <IconSelected />
                ) : (
                  <IconClose width={15} height={15} className={cn.disabled} />
                )}
                TOTP-confirmation{' '}
                {client?.totpEnabled ? 'enabled' : 'not enabled'}
              </div>
              <div className={cn.formGroup}>
                <ToggleInput
                  name="active"
                  checked={Boolean(activeStatus === 'ACTIVE')}
                  disabled={updateClientInProgress}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onUpdateClientStatus('ACTIVE');
                    } else {
                      onUpdateClientStatus('DISABLED');
                    }
                  }}
                  title="Active"
                />
              </div>
              <div className={`${cn.formGroup} ${cn.formGroupFlex}`}>
                <InputText
                  name="firstName"
                  value={client?.profile?.firstName}
                  placeholder=""
                  title="First Name"
                  labelClassName={cn.nameInput}
                  disabled
                />
                <InputText
                  name="lastName"
                  value={client?.profile?.lastName}
                  placeholder=""
                  title="Last Name"
                  labelClassName={cn.nameInput}
                  disabled
                />
              </div>
              <div className={cn.formGroup}>
                <InputText
                  name="id"
                  value={client?.id}
                  placeholder=""
                  title="Identifier"
                  disabled
                />
              </div>
              <div className={cn.formGroup}>
                <InputText
                  name="phone"
                  value={client?.phone ? formatPhone(client?.phone) : ''}
                  placeholder=""
                  title="Phone"
                  disabled
                />
              </div>
              <div className={`${cn.formGroup} ${cn.moreMargin}`}>
                <InputText
                  name="email"
                  value={client?.email || '-'}
                  placeholder=""
                  title="Email"
                  disabled
                />
              </div>
              {activePermissions?.includes(
                PermissionEnum.USERS_EDIT_ACTION,
              ) && (
                <>
                  <ButtonSecondary
                    className={cn.resetPassword}
                    text={
                      recoveryInProgress ? 'Loading...' : 'Reset user password'
                    }
                    onClick={onResetPassword}
                    bold
                  />
                  <div className={cn.resetPasswordHint}>
                    The current user password will be reset.
                  </div>
                  {/* <div className={cn.resetPasswordHint}>
                    A link to restore the password will be sent to the user.
                  </div> */}
                </>
              )}

              {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) &&
                client?.id && (
                  <NavLink
                    to={`/administration/change-logs?entityType=USER&entityId=${client?.id}`}
                    className={cn.changeLogLink}
                    target="_blank"
                  >
                    <IconChangeLoClock />
                    Change Log
                  </NavLink>
                )}
            </div>
          )}
          {userDetailsActiveTab === 'logs' && (
            <div className={cn.clientsDetailsLogs}>
              {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
                <SecuritySidepanelLogsList
                  auditLogs={auditLogs}
                  auditLogsPagination={auditLogsPagination}
                  panelIsOpen={userSidepanelVisible}
                  activePermissions={activePermissions}
                  userId={client?.id}
                  getList={getListAuditLogs}
                  schema={auditLogsSchema}
                  filtersSchema={auditLogsFiltersSchema}
                  isFetching={auditLogsIsFetching}
                  isLoading={auditLogsIsLoading}
                  columns={auditLogsColumns}
                  columnsLabels={auditLogsColumnsLabels}
                  listClassName={cn.securityLocksContent}
                />
              )}
              {!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
                <PermissionDenied />
              )}
            </div>
          )}
          {userDetailsActiveTab === 'locks' && (
            <div className={cn.clientsDetailsLogs}>
              {activePermissions?.includes(PermissionEnum.LOCKS_LIST) && (
                <SecuritySidepanelLocksList
                  users={employees}
                  locks={locks}
                  locksPagination={locksPagination}
                  userId={client?.id}
                  getList={getLocks}
                  schema={locksSchema}
                  filtersSchema={locksFiltersSchema}
                  setLockId={setLockId}
                  onBlockUserClick={() => {
                    setUserSidepanelVisible(false);
                    setLockFormVisible(true);
                  }}
                  isFetching={locksIsFetching}
                  activePermissions={activePermissions}
                  panelIsOpen={userSidepanelVisible}
                  isLoading={locksIsLoading}
                  columns={locksColumns}
                  columnsLabels={locksColumnsLabels}
                />
              )}
              {!activePermissions?.includes(PermissionEnum.LOCKS_LIST) && (
                <PermissionDenied />
              )}
            </div>
          )}
        </>
      </SidePanel>
      <SecurityLockForm
        getLockItem={getLockItem}
        getLocks={getLocks}
        create={create}
        update={update}
        lockItem={lockItem}
        takeCount={20}
        activePermissions={activePermissions}
        employees={employees}
        clearLockPanelState={() => dispatch(clearLockPanelState())}
        onClose={() => {
          setLockFormVisible(false);

          setUserSidepanelVisible(true);
          setLockId('');
        }}
        onBlockUserClick={() => {
          setUserSidepanelVisible(false);
          setLockFormVisible(true);
        }}
        isSuccess={isSuccess}
        isLoading={lockItemIsLoading}
        isFetching={lockItemIsFetching}
        userId={client?.id}
        requestInProgress={createLockRequestInProgress}
        updateInProgress={updateInProgress}
        lockIdValue={lockId}
        formPanelVisible={lockFormVisible}
        lockItemAuditLogsPagination={lockItemAuditLogsPagination}
        lockItemAuditLogs={lockItemAuditLogs}
        getLockItemLogsList={getLockItemLogsList}
        lockItemLogsSchema={logsSchema}
        lockItemLogsFiltersSchema={filtersSchema}
        lockItemLogsColumns={columns}
        lockItemLogsColumnsLabels={columnsLabels}
        lockItemLogsIsLoading={lockItemLogsIsLoading}
        lockItemLogsIsFetching={lockItemLogsIsFetching}
        withoutUserSelector
      />
      <Popup
        title="Reset customer password"
        description="Send this link to the user for password recovery"
        onCancelClick={() => setResetPopupVisible(false)}
        isVisible={resetPopupUpVisible}
        parent={document.getElementById('password-popup') as HTMLElement}
      >
        <div className={cn.applicationResetPasswordLink}>
          <div
            className={`${cn.copySuccess} ${
              resetCopyIsSuccess ? cn.visible : ''
            }`}
          >
            Copied!
          </div>
          <span>{`${link}/auth/reset-password?token=${token}`}</span>
          <button
            type="button"
            className={cn.copyButton}
            onClick={onResetCopy}
            aria-label="Copy link button"
          >
            <IconCopy />
          </button>
        </div>
      </Popup>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={manualScoreSidepanelVisible}
        onClose={() => {
          setManualScoreSidepanelVisible(false);
          setTotalRiskScore(0);
          setTotalRiskScoreLevel('');
          setManualRiskScoreError('');
        }}
        title="Set Risk Score manually"
        sidepanelExpandedKey="manual-risk-score"
        errorSidepanel={manualRiskScoreError}
        footer={
          <>
            <ButtonPrimary
              text={createRiskScoreIsLoading ? 'Loading...' : 'Apply'}
              disabled={createRiskScoreIsLoading}
              onClick={createApplicationManualRiskScoreAction}
              bold
            />
            <ButtonPseudo
              text="Close"
              onClick={() => {
                setManualScoreSidepanelVisible(false);
                setTotalRiskScore(0);
                setTotalRiskScoreLevel('');
                setManualRiskScoreError('');
              }}
              bold
            />
          </>
        }
      >
        <>
          <div className={cn.manualRiskScoreDescription}>
            Select a Risk level or enter an exact risk score value.
          </div>
          <div className={cn.manualRiskScoreFormGroup}>
            <Select
              name="riskLevel"
              title="Risk Level"
              value={totalRiskScoreLevel}
              list={riskScoreRanges?.map((item) => ({
                name: `${item.name.charAt(0)}${item.name
                  .slice(1)
                  .toLowerCase()} (${item.rangeStart} - ${item.rangeEnd})`,
                value: item.id,
                suffix: `${item.rangeStart} - ${item.rangeEnd}`,
              }))}
              onChange={(e) => {
                setTotalRiskScoreLevel(e.target.value as string);
                setTotalRiskScore(
                  riskScoreRanges?.find((item) => item.id === e.target.value)
                    ?.rangeStart as number,
                );
              }}
              fullWidth
            />
          </div>
          <div className={cn.manualRiskScoreFormGroup}>
            <InputNumber
              name="riskScore"
              title="Risk Score"
              value={totalRiskScore}
              placeholder="Enter risk score"
              maxLength={100}
              onChange={(e) => {
                clearTimeout(manualRiskScoreTimeout);
                const value =
                  Number(e.target.value) > 100 ? 100 : Number(e.target.value);

                setTotalRiskScore(value);

                manualRiskScoreTimeout = setTimeout(() => {
                  setTotalRiskScoreLevel(
                    riskScoreRanges?.find(
                      (item) =>
                        value >= item.rangeStart && value <= item.rangeEnd,
                    )?.id as string,
                  );
                }, 300);
              }}
            />
          </div>
        </>
      </SidePanel>
      <AmlChangeLogs
        panelIsOpen={riskScoreChangeLogsSidepanelVisible}
        handleCloseAmlChangeLogsPanel={handleCloseAmlChangeLogsPanel}
        getAmlChangeLogs={getApplicationsAmlScoresHistoryAction}
        amlChangeLogsIsLoading={amlScoresHistoryIsLoading}
        amlChangeLogs={amlChangeLogs}
        amlChangeLogsPagination={amlChangeLogsPagination}
        amlScoresHistoryIsFetching={amlScoresHistoryIsFetching}
        users={users}
        type={applicationType}
        applicationId={applicationId}
      />
      <div id="password-popup" />
    </>
  );
};

export default NewApplicationInfoTop;
